/**
 * Shrink text element until it fits viewport.
 *
 * @author Simon Lagerlöf <contact@smn.codes>
 * @copyright 2024 Simon Lagerlöf
 * @since 1.0.9
 */

export default function shrinkTextToFit(
  container: HTMLElement,
  text: HTMLElement,
): void {
  const containerPadding = ((): number => {
    const { paddingLeft, paddingRight } =
      window.getComputedStyle(container);

    return parseFloat(paddingLeft) + parseFloat(paddingRight);
  })();

  const viewportWidth = window.innerWidth - containerPadding;

  let fontSize = parseFloat(window.getComputedStyle(text).fontSize);

  text.style.fontSize = '';

  while (text.scrollWidth > viewportWidth && fontSize > 0) {
    fontSize -= 1;
    text.style.fontSize = `${fontSize}px`;
  }
}
